import request from '@/utils/request'

// 系统管理员API

// 登录
export function login(data) {
  return request({
    url: '/api/admin/system/admins/login',
    method: 'post',
    data
  })
}

// 登出
export function logout() {
  return request({
    url: '/api/admin/system/admins/logout',
    method: 'post'
  })
}

// 获取管理员列表
export function listAdmins(params) {
  return request({
    url: '/api/admin/system/admins',
    method: 'get',
    params
  })
}

// 获取管理员详情
export function getAdmin(adminId) {
  return request({
    url: `/api/admin/system/admins/${adminId}`,
    method: 'get'
  })
}

// 创建管理员
export function createAdmin(data) {
  return request({
    url: '/api/admin/system/admins',
    method: 'post',
    data
  })
}

// 更新管理员
export function updateAdmin(adminId, data) {
  return request({
    url: `/api/admin/system/admins/${adminId}`,
    method: 'put',
    data
  })
}

// 删除管理员
export function deleteAdmin(adminId) {
  return request({
    url: `/api/admin/system/admins/${adminId}`,
    method: 'delete'
  })
}

// 重置管理员密码
export function resetAdminPassword(adminId) {
  return request({
    url: `/api/admin/system/admins/${adminId}/reset-password`,
    method: 'post'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/api/admin/system/admins/change-password',
    method: 'post',
    data
  })
}

// 获取个人信息
export function getProfile() {
  return request({
    url: '/api/admin/system/admins/profile',
    method: 'get'
  })
}

// 更新个人信息
export function updateProfile(data) {
  return request({
    url: '/api/admin/system/admins/profile',
    method: 'put',
    data
  })
}

// 上传头像
export function uploadAvatar(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/admin/upload/avatar',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
